import styled from 'styled-components';

const Divider = styled.div`
  height: 1px;
  background-color: #c3c0c0;
  margin-top: 20px;
`;

export default Divider;
